
export class PermisoPantalla {
    consultar: boolean = false;
    agregar: boolean = false;
    editar: boolean = false;
    eliminar: boolean = false;
    exportar: boolean = false;
    edicionespecial: boolean = false;
    evaluador: boolean = false;


    constructor(init?: Partial<PermisoPantalla>) {
        Object.assign(this, init);
    }
}
